import { render, staticRenderFns } from "./CopyText.vue?vue&type=template&id=aaaa70ca&scoped=true"
import script from "./CopyText.vue?vue&type=script&lang=js"
export * from "./CopyText.vue?vue&type=script&lang=js"
import style0 from "./CopyText.vue?vue&type=style&index=0&id=aaaa70ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaaa70ca",
  null
  
)

export default component.exports